export default{
    "my-patients":"My Clients",
    "patient-detail":"Client Detail",
    "my-appointments":"My Appointments",
    "appointments":"Consultations",
    "health-profile": "Health Information",
    "my-patientsdetails": "Consultation History",
    "my-availability": "My Availability",
    "my-availability-new-version": "My Availability (Beta Version)",
    "dashboard": "Dashboard",
    "my-account": "My Profile",
    "my-account-child": "My Profile",
    "video-consultation":"Video Consultation",
    "select-assessment": "Take Assessment",
    "take-assessment":"Take Assessment",
    "emotion": "Self Assessment Depression",
    "stress": "Self Assessment Stress",
    "assessment-history": "Assessments",
    "score-details": "Assessment Score Details",
    "schedule-appointment": "New Appointment",
    "consultation-history": "Appointments",
    "select-doctor": "Select Doctor",
    "subscription-plan": "Membership Plan",
    "my-order": "My Orders",
    "select-tickets":"My Tickets",
    "tickets-list":"Tickets",
    "search-patient":"Clients",
    "add-medicine":"Medicines",
    "doctor-availabilty":"Doctors",
    "org-records":"B2B Records",
    "analytics":"Analytics",
    "reports":"Reports",
    "all-patients":"Clients",
    "table":"Records",
    "consultation-list":"Consultations",
    "patient-lists":"Patient Details",
    "patient-plan":"Plan Statistics",
    "plan-history":"Plan History",
    "patient-records":"Patient Details",
    "patient-consultation":"Patient Consultations",
    "my-tickets":"My Tickets",
    "chat":"Chat",
    "manage-coupon":"Coupons",
    "document-upload":"Document upload",
    "instructions":"Instructions"
}